// MyZac newsletter pop-up. See sections/myzac-popup.liquid.
(() => {
  const popup = document.getElementById('mz-popup');
  if (!popup) return;

  const KEY = 'mzPopup';
  const DISMISS_DAYS = 30;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  };
  const write = (data) => {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) { /* private mode */ }
  };

  const dialog = popup.querySelector('[role="dialog"]');
  let lastFocus = null;
  let stopTriggers = () => {};

  const focusables = () =>
    [...dialog.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])')].filter(
      (el) => !el.disabled && el.offsetParent !== null
    );

  const open = () => {
    if (!popup.hidden) return;
    stopTriggers();
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('mz-popup-open');
    const done = dialog.querySelector('[data-mz-signup-done]');
    (done || dialog.querySelector('input[type="email"]') || focusables()[0])?.focus();
  };

  const close = () => {
    popup.hidden = true;
    document.documentElement.classList.remove('mz-popup-open');
    const state = read();
    if (!state.subscribed) write({ ...state, dismissedAt: Date.now() });
    lastFocus?.focus?.();
  };

  popup.addEventListener('click', (e) => {
    if (e.target.closest('[data-mz-popup-close]')) close();
    const copy = e.target.closest('.mz-signup__copy');
    if (copy) {
      navigator.clipboard?.writeText(copy.dataset.code).then(() => { copy.textContent = 'Copied'; });
    }
  });
  popup.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Came back from submitting the pop-up form: show the result, remember sign-up.
  if (location.hash === '#mz-popup') {
    if (dialog.querySelector('[data-mz-signup-done]')) write({ subscribed: true });
    open();
    return;
  }

  const state = read();
  if (state.subscribed) return;
  if (state.dismissedAt && Date.now() - state.dismissedAt < DISMISS_DAYS * 864e5) return;

  // Open once: after the delay or half-page scroll, whichever comes first.
  const delay = (parseInt(popup.dataset.delay, 10) || 20) * 1000;
  const onScroll = () => {
    const scrolled = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    if (scrolled > 0.5) open();
  };
  const timer = setTimeout(open, delay);
  window.addEventListener('scroll', onScroll, { passive: true });
  stopTriggers = () => {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  };
})();
